import React, { Component } from 'react';
import TablaProforma from '../NuevaFichaVenta/TablaProforma';
import Pills from '../NuevaFichaVenta/Pills';

class FirstStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedProform: this.props.selectedProform,
      proformInput: '',
    };
  }

  onChangeValue = (e) => {
    const { fdv } = this.props;
    this.setState({ [e.target.name]: e.target.value });
    if (!e.target.value) {
      this.props.searchProformas(fdv.codClie, null, fdv.codAreaVta, fdv.codCia, fdv.vendedor);
    }
  }

  searchProforma = () => {
    const { fdv } = this.props;
    const { proformInput } = this.state;
    if (proformInput) {
      this.props.searchProformas(fdv.codClie, proformInput,
                                  fdv.codAreaVta, fdv.codCia, fdv.vendedor);
    }
  }


  unselectProforma = (proforma) => {
    this.setState({
      selectedProform: this.state.selectedProform.filter(it => it !== proforma.proforma),
    });
  };

  render() {
    const {  proformInput } = this.state;
    const { selectedProform } = this.props;


    return (
      <div>
        <Pills proformas={selectedProform} unselectProforma={this.unselectProforma} />
        <h4 className='mt-4 mb-2 labelInfo'>Buscar por número de proforma:</h4>
        <div className='row'>
          <div className='col-md-6 mb-3 mt-2'>
            <div className='input-group'>
              <input
                type='text'
                name='proformInput'
                className='fSearch-search form-control'
                placeholder='Ingrese el número de proforma'
                value={proformInput}
                onChange={this.onChangeValue}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.searchProforma();
                  }
                }}
              />
              <span className='input-group-btn'>
                <button
                  className='btn btn-dark fSearch-go'
                  type='button'
                  onClick={this.searchProforma}
                >
                  <i className='ion-android-arrow-forward' />
                </button>
              </span>
            </div>
          </div>
        </div>
        <TablaProforma
          proformas={this.props.proformas}
          selectedProform={this.props.selectedProform}
          selectProform={this.props.selectProform}
          paginateProform={this.props.paginateProform}
        />
        <div className='modal-actions'>
          <button
            type='submit'
            className='btn btn-primary pull-right'
            onClick={() => this.props.nextStep(this.state)}
            disabled={selectedProform.length < 1}
          >
            Siguiente
          </button>
        </div>
      </div>
    );
  }
}

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/AsignarProformas/FirstStep.js